var _path, _path2, _path3, _path4, _path5, _circle, _text, _line;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "5 15 125 90",
    width: 128,
    height: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "mg",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#2d6a4f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#40916c"
    }
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 95 L68 25 L96 95",
    fill: "url(#mg)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57 45 L68 25 L79 45 L75 47 L70 43 L64 47 Z",
    fill: "white",
    opacity: 0.85
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 95 L45 42 L65 75 L40 95",
    fill: "#40916c",
    opacity: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36 55 L45 42 L54 55 L50 57 L47 53 L42 57 Z",
    fill: "white",
    opacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72 95 L95 52 L118 95",
    fill: "#52b788",
    opacity: 0.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 35,
    r: 12,
    fill: "#f4a261",
    opacity: 0.8
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 82,
    fontFamily: "'Montserrat', 'Segoe UI', 'Helvetica Neue', Arial, sans-serif",
    fontWeight: 700,
    fontSize: 28,
    fill: "white",
    opacity: 0.9,
    letterSpacing: 5
  }, "HY")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 86,
    x2: 88,
    y2: 86,
    stroke: "#f4a261",
    strokeWidth: 1.5,
    opacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.2fcd02c778b4d638d5d3974e353b6e07.svg";
export { ForwardRef as ReactComponent };